import { Theme } from '@emotion/react';
import { get } from 'lodash-es';
import { TextAlignment } from './provider/config-provider';
import themes from './themes.json';

type GlobalTheme = keyof typeof themes;

function getTheme(theme: keyof typeof themes) {
  if (theme in themes) {
    return themes[theme];
  }

  return theme in themes ? themes[theme] : themes['Blue 900'];
}

function getTokenFromVibrant(path: string, theme: Theme) {
  const foundValue = get(theme, path) as string;
  return foundValue ? foundValue : path;
}

function getTextAlignment(cardTextAlignment: TextAlignment) {
  return cardTextAlignment === 'Left'
    ? 'left'
    : cardTextAlignment === 'Center'
      ? 'center'
      : 'right';
}

export { getTheme, getTokenFromVibrant, getTextAlignment };
export type { GlobalTheme };
